import { useLocation } from 'react-router-dom';

import RegistrationForm from '../../components/RegistrationForm/RegistrationForm';
import PageContainer from '../../components/PageContainer/PageContainer';
import logo from '../../img/logo.png';

import css from './RegistrationPage.module.css';
import { STORAGE_KEYS, STORAGE_VALUES } from '../../constants/common-app.const';

const Registration = () => {
  const { search } = useLocation();
  const typeParam = new URLSearchParams(search).get(STORAGE_KEYS.TYPE);

  const type: keyof typeof STORAGE_VALUES | undefined = !!typeParam
    ? STORAGE_VALUES.course
    : undefined;

  return (
    <PageContainer>
      <div className={css.Wrapper}>
        <img className={css.Logo} src={logo} alt='Logo' />
        <RegistrationForm type={type} />
      </div>
    </PageContainer>
  );
};

export default Registration;
